import React, { useEffect, useMemo, useState } from "react";
import { getVatPeriodList } from "../../../../store/generalSettings/action";
import { useDispatch, useSelector } from "react-redux";
import PeriodReports from "../../../../Components/Page/Settings/Company/PeriodReports";

export default function VatPeriod({ page }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getVatPeriodList());
  }, []);
  const { vatPeriodListAPI } = useSelector((state) => ({
    vatPeriodListAPI: state.GeneralSettings.vatPeriodList?.vatperiod_list,
  }));

  return (
    <>
      <PeriodReports
        data={vatPeriodListAPI}
        page={page}
        tab={"vatPeriod"}
        reportName={"vatPeriod"}
      />
    </>
  );
}
